// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal_calendar {
  background-color: #f7f7f7 !important;
  border: 2px solid #f7f7f7;
  width: 100%;
}

li.Calendar__monthSelectorItem button,
li.Calendar__yearSelectorItem button {
  font-size: 14px;
}

.Calendar__monthSelector {
  background-color: #f7f7f7 !important;
}

.Calendar__yearSelectorAnimationWrapper {
  overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./app/theme/web/web-style.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".modal_calendar {\n  background-color: #f7f7f7 !important;\n  border: 2px solid #f7f7f7;\n  width: 100%;\n}\n\nli.Calendar__monthSelectorItem button,\nli.Calendar__yearSelectorItem button {\n  font-size: 14px;\n}\n\n.Calendar__monthSelector {\n  background-color: #f7f7f7 !important;\n}\n\n.Calendar__yearSelectorAnimationWrapper {\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
